export default (theme) => ({
  notReadyRow: {
    backgroundColor: theme.palette.action.hover,
  },
  mutedText: {
    color: theme.palette.text.secondary,
  },
});
